import { Draft } from 'immer';
import { produce } from "immer";
import { DatosComprador } from '@/schemas/checkout.schema';
import { EventoStore } from "./evento";

export interface CompradorSlice {
    state: DatosComprador | null;
    set: (comprador: DatosComprador | null) => void;
    clear: () => void;
}

export const createCompradorSlice = (set: any): CompradorSlice => ({
    state: null,
    set: (comprador) => set(produce((state: Draft<EventoStore>) => { state.comprador.state = comprador; })),
    clear: () => set(produce((state: Draft<EventoStore>) => { state.comprador.state = null; })),
});

